// Library Imports
import { Col, Row } from 'antd';
import React, { FC, Suspense } from 'react';

// Local Imports
import CustomChart from './Components/CustomChart';
import ExportAnalyticsPopup from '../Shared/ExportAnalyticsPopup';
import { getQueryCampaignId, getQueryEmailId } from 'modules/EmailBrowser/utils';

// Lazy Imports
const StatsBar = React.lazy(() => import('./Components/StatsBar'));
const TopPeople = React.lazy(() => import('./Components/TopPeople'));
const TopContent = React.lazy(() => import('./Components/TopContent'));
const TopAccounts = React.lazy(() => import('./Components/TopAccounts'));

interface IAnalyticsDashboard {
  page?: string;
  tab?: string;
}

const AnalyticsDashboard: FC<IAnalyticsDashboard> = (props: IAnalyticsDashboard) => {
  // Local variables
  const emailId = getQueryEmailId();
  const campaignId = getQueryCampaignId();

  return (
    <>
      <Row>
        <Col span={24} className="py-2 my-1">
          <div className="chart-container">
            <CustomChart
              title={'Engagement overview'}
              boxRightOffset={'1.3%'}
              campaignId={campaignId}
              emailId={emailId}
              tooltip={'Hover over data points for detailed insights. Colors represent distinct campaigns (up to 4 campaigns supported).'}
            />
          </div>
        </Col>
        <Suspense fallback={<></>} children={<StatsBar />} />
      </Row>
      <Row gutter={26} className="mb-5">
        <Suspense fallback={<></>} children={<TopAccounts />} />
        <Suspense fallback={<></>} children={<TopPeople />} />
        <Suspense fallback={<></>} children={<TopContent />} />
      </Row>
      <ExportAnalyticsPopup page={'dashboard'} />
    </>
  );
};

export default AnalyticsDashboard;
